import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";

export default function AdminStaffOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const currentUserId = user?.id || user?.userID;
      const role = String(user?.role || "").toUpperCase();

      // Fetch specifically offline orders handled by admins/staff
      const res = await axiosInstance.get("/api/orders/admin?type=OFFLINE");
      const dataList = res.data?.orders || res.data?.data || [];
      
      // Filter offline orders locally
      let offlineOrders = dataList.filter(o => 
        ["OFFLINE", "CASH", "BANK", "UPI"].includes(String(o?.paymentMethod || "").toUpperCase())
        && o.createdByAdminId != null
      );

      // If STAFF, only show their own specific orders. Admins see all.
      if (role === "STAFF") {
        offlineOrders = offlineOrders.filter(o => String(o.createdByAdminId) === String(currentUserId));
      }

      setOrders(offlineOrders);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <div style={styles.h1}>Admin / Staff Orders</div>
          <div style={styles.sub}>Particular details of offline orders created by Admin/Staff members</div>
        </div>
        <button style={styles.btn} onClick={() => navigate(-1)}>← Back</button>
      </div>

      <div style={styles.card}>
        {loading ? (
          <div style={styles.muted}>Loading offline orders...</div>
        ) : orders.length === 0 ? (
          <div style={styles.muted}>No admin/staff offline orders found.</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Order ID</th>
                  <th style={styles.th}>Customer Name</th>
                  <th style={styles.th}>Customer Role</th>
                  <th style={styles.th}>Amount</th>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Payment Method</th>
                  <th style={styles.th}>Created By (Staff/Admin)</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((o) => (
                  <tr key={o.id}>
                    <td style={styles.td}>#{o.id}</td>
                    <td style={styles.td}>{o.User?.name || o.userId || "N/A"}</td>
                    <td style={styles.td}>
                      <span style={{...styles.badge, background: o.User?.role === "USER" ? "#e0f7fa" : "#fff3e0", color: o.User?.role === "USER" ? "#006064" : "#e65100"}}>
                        {o.User?.role || "USER"}
                      </span>
                    </td>
                    <td style={styles.td}>₹{Number(o.totalAmount || o.total || 0).toFixed(2)}</td>
                    <td style={styles.td}>{o.createdAt ? new Date(o.createdAt).toLocaleString() : "-"}</td>
                    <td style={styles.td}>{o.paymentMethod || "-"}</td>
                    <td style={{ ...styles.td, fontWeight: "bold" }}>{o.CreatedByAdmin?.name || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    padding: 20,
    minHeight: "100vh",
    background: "#f4f6f8",
    fontFamily: "Segoe UI, Inter, system-ui, sans-serif",
    color: "#111"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: 20,
    flexWrap: "wrap",
    gap: 10
  },
  h1: { fontSize: 24, fontWeight: "bold" },
  sub: { fontSize: 14, color: "#666", marginTop: 4 },
  btn: {
    padding: "10px 16px",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold"
  },
  card: {
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    border: "1px solid rgba(0,0,0,0.05)"
  },
  table: { width: "100%", borderCollapse: "collapse" },
  th: {
    textAlign: "left",
    padding: 12,
    borderBottom: "2px solid #eee",
    color: "#666",
    fontSize: 13,
    textTransform: "uppercase"
  },
  td: {
    padding: 12,
    borderBottom: "1px solid #f2f2f2",
    fontSize: 14,
    color: "#333"
  },
  muted: {
    color: "#666",
    fontSize: 14
  },
  badge: {
    padding: "4px 8px",
    borderRadius: 6,
    fontSize: 12,
    fontWeight: "bold"
  },
  roleBadge: {
    padding: "4px 8px",
    borderRadius: 6,
    fontSize: 12,
    fontWeight: "bold",
    background: "#e8eaf6",
    color: "#283593"
  }
};
